<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <!-- <div class="personal-details">
              
            <h4 class="list-details-title">Employee Attendence</h4>
            <div class="attendence-search">
              <div class="" style="padding-right: 20px;">
                  <input type="date" [(ngModel)]="date1" class="form-control">
              </div>
              <div class="" >
                  <button (click)="getUserLoginData()" class="btn btn-primary">search</button>
              </div>
            </div>
                <table class="table table-striped" *ngIf="UserLoginData != 0">
                    <thead>
                      <tr>
                        <th style="width: 10%;">User Id</th>
                        <th style="width: 10%;">User Name</th>
                        <th style="width: 80%;">Work Hours</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  data-toggle="modal" data-target="#viewModal" (click)="getUserAttendenceById(data.userId)" *ngFor="let data of UserLoginData;let i = index">
                        <th style="width: 10%;">{{data.userId}}</th>
                        <th style="width: 10%;">{{data.userName}}</th>
                        <th style="width: 80%;overflow: auto;">
                          <p-timeline [value]="data.loginHistory" layout="horizontal" align="alternate">
                            <ng-template style="padding: 0;" pTemplate="content" let-event> 
                              <div>
                                {{event.type}}
                                <br>
                                {{event.status | date : 'shortTime'}}
                              </div>
                            </ng-template>
                          </p-timeline>

                          
                        </th>
                      </tr>
                    </tbody>
                </table>      
              </div> -->

              <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                      <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off" >
                                <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="date1">
                            </form>
                        </div>
                        <button (click)="getUserLoginData()">search</button>

                    </div>
                </div>
              
                <table class="table table-striped" *ngIf="UserLoginData != 0">
                  <thead>
                    <tr>
                      <th style="width: 10%;">User Id</th>
                      <th style="width: 10%;">User Name</th>
                      <th style="width: 80%;">Work Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr  data-toggle="modal" data-target="#viewModal" (click)="getUserAttendenceById(data.userId)" *ngFor="let data of UserLoginData;let i = index">
                      <th style="width: 10%;">{{data.userId}}</th>
                      <th style="width: 10%;">{{data.userName}}</th>
                      <th style="width: 80%;overflow: auto;">
                        <p-timeline [value]="data.loginHistory" layout="horizontal" align="alternate">
                          <ng-template style="padding: 0;" pTemplate="content" let-event> 
                            <div>
                              {{event.type}}
                              <br>
                              {{event.status | date : 'shortTime'}}
                            </div>
                          </ng-template>
                        </p-timeline>

                        
                      </th>
                    </tr>
                  </tbody>
                </table>   
         
        
        
          
        
          
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1"  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Details
          <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="attendence-block">
          <div class="row">
            <div class="col-lg-3 col-md-3">
              <div class="form-group">
                <label for="">Name</label>
                <p>{{SingleUserData.userName}}</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-3">
              <div class="form-group">
                <label for="">User Id</label>
                <p>{{SingleUserData.userId}}</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-3">
              <div class="form-group">
                <label for="">Date</label>
                <p>{{SingleUserData.date | date}}</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-3">
              <div class="form-group">
                <label for="">Status</label>
                <p>{{currentStatus(SingleUserData.currentStatus)}}</p>
              </div>
            </div>
          </div>

          <div class="attendence-list">
            <div class="row attendence-header">
              <div class="col-lg-4">
                <p>Login</p>
              </div>
              <div class="col-lg-4">
                <p>Logout</p>
              </div>
              <div class="col-lg-4">
                <p>Active Time</p>
              </div>
            </div>
            <div class="list" *ngFor="let list of SingleUserData.loginHistory">
              <div class="row">
                <div class="col-lg-4">
                  <p>{{list.startTime | date : 'shortTime'}}</p>
                </div>
                <div class="col-lg-4">
                  <p>{{list.endTime | date : 'shortTime'}}</p>
                </div>
                <div class="col-lg-4">
                  <p *ngIf="list.startTime != null && list.endTime != null">{{calculateTimeDifference1(list.startTime,list.endTime)}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>